module.exports = __webpack_public_path__ + "fromBrideToMother-we-p.8402d6fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/fromBrideToMother-we-p.jpg
// module id = pjp6
// module chunks = 0